import type { Theme } from '@mui/material';

const titleTextStyle = {
  width: '100%',
  textAlign: 'left',
  fontSize: '2rem',
  padding: '1rem',
  lineHeight: 1,
  color: (theme: Theme) => theme.palette.baseColors.fireOrange.c100,
};

const slotStyle = {
  fontSize: '3rem',
  fontWeight: 800,
  color: (theme: Theme) => theme.palette.baseColors.fireOrange.c100,
  fontFamily: (theme: Theme) => theme.fonts.inter,
  justifyContent: 'center',
};

const typography1Style = {
  ...titleTextStyle,
  width: 'auto',
  fontSize: '3rem',
  fontWeight: 800,
};

const typography2Style = {
  ...titleTextStyle,
  width: 'auto',
  fontWeight: 800,
  color: 'white',
};

const typography3Style = {
  ...titleTextStyle,
  width: 'auto',
  fontWeight: 400,
  color: 'white',
};

export const styles = {
  logoBox: {
    top: '5rem',
    left: '5rem',
  },
  logoBoxThumbnail: {
    top: '1rem',
    left: '1rem',
  },
  textFieldPlaceholder1: {
    ...typography1Style,

    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c75,
    },

    '.textFieldPlaceholderText': {
      ...slotStyle,
    },

    '.textFieldPlaceholderInput': {
      ...slotStyle,
    },

    '.textFieldPlaceholderIcon': {
      color: (theme: Theme) => theme.palette.baseColors.fireOrange.c100,
      opacity: 0.75,
    },
  },

  textFieldPlaceholder2: {
    ...typography2Style,

    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c75,
    },

    '.textFieldPlaceholderText': {
      ...slotStyle,
      color: 'white',
      fontSize: '2rem',
    },

    '.textFieldPlaceholderInput': {
      ...slotStyle,
      color: 'white',
      fontSize: '2rem',
    },

    '.textFieldPlaceholderIcon': {
      color: 'white',
    },
  },
  textFieldPlaceholder3: {
    ...typography3Style,

    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c75,
    },

    '.textFieldPlaceholderText': {
      ...slotStyle,
      fontSize: '2rem',
      fontWeight: 400,
      color: 'white',
    },

    '.textFieldPlaceholderInput': {
      ...slotStyle,
      fontSize: '2rem',
      fontWeight: 400,
      color: 'white',
    },

    '.textFieldPlaceholderIcon': {
      color: 'white',
    },
  },
  typography1: typography1Style,
  typography2: typography2Style,
  typography3: typography3Style,
  titlePageRoot: {
    padding: '5rem',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    fontFamily: (theme: Theme) => `${theme.fonts.base}`,
  },
  titlePageRootThumbnail: {
    padding: '1rem',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    fontFamily: (theme: Theme) => `${theme.fonts.base}`,
  },
  typographyThumbnail: {
    width: '100%',
    marginBottom: 0,
    padding: 0,
    fontSize: '0.5rem',
    lineHeight: 1,
  },
};
